import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Router } from '@angular/router';
import * as _ from 'lodash';
import { ApiEvsService } from './ApiEvs.service';
import { environment } from '../../../environments/environment';

export type PageQuery = {
  page_size: number;
  page: number;
};

export type GetQuery = PageQuery & {
  sort_by?: string;
};

export enum FilterType {
  ONE_TICKET = 0,
  MULTIPLE_TICKET = 1,
}

export enum CallDirection {
  INBOUND = 0,
  OUTBOUND = 1,
}

export enum QCStatus {
  PENDING = 0,
  RUNNING = 1,
  DONE = 2,
}

export enum QCCallStatus {
  SEND_TO_QUEUE = 0,
  SEND_TO_EMAS = 1,
  RECEIVE_FROM_EMAS = 2,
}

export type FilterPayload = {
  code?: string;
  ticket_from?: string;
  ticket_to?: string;
  ticket_from_time?: string;
  ticket_to_time?: string;
  assign_agent_id?: Array<string>;
  assign_group_id?: Array<string>;
  status?: Array<number>;
  type_id?: Array<string>;
  priority_id?: Array<string>;
  call_duration_from?: string;
  call_duration_to?: string;
  call_direction?: CallDirection;
  call_status?: Array<string>;
};

export type FormQCModel = FilterPayload & {
  name: string;
  description?: string;
  filter_type: FilterType;
  maximum_audio: number;
  call_direction: Array<CallDirection>;
};

export type CreateQCPayload = {
  name: string;
  description?: string;
  filter_type: FilterType;
  filter_payload: FilterPayload;
  maximum_audio: number;
};

export type UpdateQCPayload = Partial<CreateQCPayload>;

export type ExecuteQCCampaignPayload = {
  qc_campaign_id: string;
};

export type CampaignQCTicketFilter = {
  code?: string;
  ticket_from?: string;
  ticket_to?: string;
  ticket_from_time?: string;
  ticket_to_time?: string;
  assign_agent_id?: Array<string>;
  assign_group_id?: Array<string>;
  status?: Array<number>;
  type_id?: Array<string>;
  priority_id?: Array<string>;
};

export type CampaignQCCallFilter = {
  call_duration_from?: string;
  call_duration_to?: string;
  call_direction?: CallDirection;
  call_status?: Array<string>;
};

export type CampaignQC = {
  _id: string;
  name: string;
  description?: string;
  tenant_id: string;
  status: QCStatus;
  filter_type: FilterType;
  ticket_filter: CampaignQCTicketFilter;
  call_filter: CampaignQCCallFilter;
  manual: boolean;
  maximum_audio: number;
  created_at: string;
  updated_at: string;
  created_by: string;
  updated_by: string;
  start_running?: string;
  end_running?: string;
};

export type ViewCampaignQC = CampaignQC & {
  index: number;
  display_btn_view_campaign: boolean;
  display_btn_execute_campaign: boolean;
  display_btn_view_report: boolean;
  display_btn_edit_campaign: boolean;
  display_status: string;
  display_time: string;
};

export type CampaignQCCall = {
  _id: string;
  qc_campaign_id: string;
  ticket_id: string;
  call_id: string;
  provider_source: string;
  status: QCCallStatus;
  created_at: string;
  updated_at: string;
  provider_call_id: string;
  call_analyze?: any;
  agent: {
    _id: string;
    name: string;
    email: string;
    phone: string;
    active: boolean;
  };
};

export type ViewCampaignQCCall = {
  _id: string;
  qc_campaign_id: string;
  ticket_id: string;
  call_id: string;
  provider_source: string;
  status: QCCallStatus;
  created_at: string;
  updated_at: string;
  provider_call_id: string;
  call_analyze?: any;
  agent: {
    _id: string;
    name: string;
    email: string;
    phone: string;
    active: boolean;
  };
  index: number;
  display_startTime: string;
  display_scriptName: string;
  display_emotionCustomer: string;
  display_emotionAgent: string;
  display_endCallStatus: string;
  display_qcStatus: string;
  display_qcCategory: string;
  display_agentName: string;
  display_qcPercent: string;
};

export type CampaignQCCallInfo = {
  agentName: string;
  caller: string;
  startTime: string;
  endTime: string;
  duration: number;
  callUrl: string;
  callId: string;
  sems: string;
};

export type ViewCampaignQCCallInfo = CampaignQCCallInfo & {
  display_startTime: string;
  display_endTime: string;
  display_duration: string;
};

export type CampaignQCCallHistory = {
  key: string;
  scriptMaxScoreMain: number;
  scriptMaxScoreOther: number;
  categoryName: string;
  creator?: string;
  createdAt: string;
  qcScore: number;
  scorePercent: number;
  isAuto: string;
};

export type ViewCampaignQCCallHistory = CampaignQCCallHistory & {
  display_createdAt: string;
  display_creator: string;
  display_scorePercent: string;
  display_categoryName: string;
};

export type CampaignQCCallConversation = {
  id: string;
  speaker: string;
  text: string;
  textRaw: string;
  startTime: number;
  endTime: number;
};

export type ViewCampaignQCCallConversation = CampaignQCCallConversation & {
  display_startTime: string;
};

type Criteria = {
  key: string;
  code: string;
  name: string;
};

export type CampaignQCCallAnalyze = {
  createdAt: string;
  callKey: string;
  startTime: string;
  emotion: number;
  emotionAgent: number;
  emotionCustomer: number;
  endcallStatus: number;
  intents: any[];
  intentMisses: any[];
  criterias: Criteria[];
  wordAgentForbids: any[];
  wordAgentUnPros: any[];
  wordAgentGoods: any[];
  wordCustomerGoods: any[];
  wordCustomerBads: any[];
  wordSequence: any[];
  wordSpecial: any[];
  wordLocation: string[];
  duration: number;
  durationMinute: number;
  durationSecond: number;
  durationMinuteCharge: number;
  talkPercent: number;
  silencePeriods: any[];
  customerAgentDistances: any[];
  longDistanceHolds: any[];
  avgWordPerMin: number;
};

export type WordSequence = {
  keyword: string;
  time?: string;
};

export type ViewCampaignQCCallAnalyze = CampaignQCCallAnalyze & {
  display_createdAt: string;
  display_emotion: string;
  display_emotionAgent: string;
  display_emotionCustomer: string;
  display_endCallStatus: string;
  display_intents: string;
  display_intentMisses: string;
  display_wordCustomerSequence: WordSequence[];
  display_wordAgentSequence: WordSequence[];
  display_wordAgentGoods: WordSequence[];
  display_wordAgentUnPros: WordSequence[];
  display_wordAgentForbids: WordSequence[];
  display_wordCustomerGoods: WordSequence[];
  display_wordCustomerBads: WordSequence[];
  display_wordSpecial: WordSequence[];
};

export type GetQCCategoryQuery = GetQuery & {
  name?: string;
};

export type QCCategory = {
  _id: string;
  name: string;
  description?: string;
  tenant_id: string;
  created_at: string;
  updated_at: string;
  created_by: string;
  updated_bt: string;
};

export type CreateQCCategoryPayload = {
  name: string;
  description?: string;
};

export type UpdateQCCategoryPayload = Partial<CreateQCCategoryPayload>;

export type GetQCKeywordQuery = GetQuery & {
  code?: string;
};

export type QCKeyword = {
  _id: string;
  code: string;
  tenant_id: string;
  created_at: string;
  updated_at: string;
  created_by: string;
  updated_bt: string;
  categoryIds: string[];
};

export type CreateQCKeywordPayload = {
  code: string;
  categoryIds?: string[];
};

export type UpdateQCKeywordPayload = Partial<CreateQCKeywordPayload>;

export enum CRITERIA_TYPE {
  AUTO = 'auto',
  MANUAL = 'manual',
}

export enum CRITERIA_OBJECT_TYPE {
  AGENT = 'agent',
  OTHER = 'other',
}

export type QCCriteria = {
  _id: string;
  code: string;
  name: string;
  description: string;
  type: CRITERIA_TYPE;
  object_type: CRITERIA_OBJECT_TYPE;
  tenant_id: string;
  created_at: string;
  updated_at: string;
  created_by: string;
  updated_bt: string;
};

export type CreateQCCriteriaPayload = {
  code: string;
  name: string;
  description: string;
  type: CRITERIA_TYPE;
  object_type: CRITERIA_OBJECT_TYPE;
};

export type UpdateQCCriteriaPayload = Partial<CreateQCCriteriaPayload>;

export type GetQCCriteriaQuery = GetQuery & {
  name?: string;
};

export type ViewQCCriteria = QCCriteria & {
  display_type: string;
  display_object_type: string;
};

export type GetSummaryQuery = {
  start_date: string;
  end_date: string;
};

export type QCSummaryCall = {
  total_qc: number;
  total_seconds: number;
  maximum_duration_seconds: number;
  minimum_duration_seconds: number;
  total_success: number;
  total_error: number;
  total_silence_duration: number;
};

export type ViewQCSummaryCall = QCSummaryCall & {
  display_total_minutes: number;
  display_maximum_duration: string;
  display_minimum_duration: string;
  display_total_success_percent: string;
  display_total_error_percent: string;
};

export type QCSummaryEmotion = {
  emotion: string;
  count: number;
};

export type ViewQCSummaryEmotion = QCSummaryEmotion & {
  backgroundColor: string;
  label: string;
};

export type QCSummaryAgent = {
  caller: string;
  total_call_per_caller: number;
  percentage: number;
};

@Injectable()
export class SmartQcService extends ApiEvsService {
  constructor(http: Http, router: Router) {
    super(http, router);
  }

  getCampaignQC(qcId: string) {
    return this.get(`/v2/smart-qc/${qcId}`);
  }

  getCampaignQCs(query: GetQuery) {
    return this.get(`/v2/smart-qc?page=${query.page}&page_size=${query.page_size}`);
  }

  createCampaignQC(body: CreateQCPayload) {
    return this.post('/v2/smart-qc', body);
  }

  updateCampaignQC(qcId: string, body: UpdateQCPayload) {
    return this.put(`/v2/smart-qc/${qcId}`, body);
  }

  executeQCCampaign(body: ExecuteQCCampaignPayload) {
    return this.post(`/v2/smart-qc/execute-campaign`, body);
  }

  deleteQCCampaign(qcId: string) {
    return this.delete(`/v2/smart-qc/${qcId}`);
  }

  getCampaignQCCalls(qcId: string, query: GetQuery) {
    return this.get(`/v2/smart-qc/${qcId}/calls?page=${query.page}&page_size=${query.page_size}`);
  }

  getCampaignQCCallHistory(qcId: string, qcTicketId: string) {
    return this.get(`/v2/smart-qc/${qcId}/calls/${qcTicketId}/history`);
  }

  getCampaignQCCallConversation(qcId: string, qcTicketId: string) {
    return this.get(`/v2/smart-qc/${qcId}/calls/${qcTicketId}/conversation`);
  }

  getCampaignQCCallAnalyze(qcId: string, qcTicketId: string) {
    return this.get(`/v2/smart-qc/${qcId}/calls/${qcTicketId}/data-analyze`);
  }

  getCampaignQCCallInfo(qcId: string, qcTicketId: string) {
    return this.get(`/v2/smart-qc/${qcId}/calls/${qcTicketId}/info`);
  }

  async exportFull(qcId: string, qcTicketId: string) {
    const headers = {};
    const accessToken = localStorage.getItem('Access-Token');
    if (accessToken) {
      headers['Authorization'] = accessToken;
    }

    return fetch(`${environment.api_evs}/v2/smart-qc/${qcId}/calls/${qcTicketId}/export/full`, {
      method: 'GET',
      headers,
    }).then(response => response.blob());
  }

  async exportText(qcId: string, qcTicketId: string) {
    const headers = {};
    const accessToken = localStorage.getItem('Access-Token');
    if (accessToken) {
      headers['Authorization'] = accessToken;
    }

    return fetch(`${environment.api_evs}/v2/smart-qc/${qcId}/calls/${qcTicketId}/export/text`, {
      method: 'GET',
      headers,
    }).then(response => response.blob());
  }

  async exportCSV(qcId: string, qcTicketIds: string[]) {
    const headers = {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    };

    const accessToken = localStorage.getItem('Access-Token');
    if (accessToken) {
      headers['Authorization'] = accessToken;
    }

    return fetch(`${environment.api_evs}/v2/smart-qc/${qcId}/calls/export/csv`, {
      method: 'POST',
      headers,
      body: JSON.stringify({
        qc_ticket_ids: qcTicketIds,
      }),
    }).then(response => response.blob());
  }

  getQCCategories(query: GetQCCategoryQuery) {
    let url = `/v2/smart-qc/settings/categories?page=${query.page}&page_size=${query.page_size}`;

    if (query.name) {
      url += `&name=${query.name}`;
    }

    return this.get(url);
  }

  createQCCategory(body: CreateQCCategoryPayload) {
    return this.post('/v2/smart-qc/settings/categories', body);
  }

  updateQCCategory(qcCategoryId: string, body: UpdateQCCategoryPayload) {
    return this.put(`/v2/smart-qc/settings/categories/${qcCategoryId}`, body);
  }

  deleteQCCategory(qcCategoryId: string) {
    return this.delete(`/v2/smart-qc/settings/categories/${qcCategoryId}`);
  }

  getQCKeywords(query: GetQCKeywordQuery) {
    const payload: any = {
      page: query.page,
      page_size: query.page_size,
    };

    if (query.code) {
      payload.code = query.code;
    }

    return this.post('/v2/smart-qc/settings/keywords/search');
  }

  createQCKeyword(body: CreateQCKeywordPayload) {
    return this.post('/v2/smart-qc/settings/keywords', body);
  }

  updateQCKeyword(qcKeywordId: string, body: UpdateQCKeywordPayload) {
    return this.put(`/v2/smart-qc/settings/keywords/${qcKeywordId}`, body);
  }

  deleteQCKeyword(qcKeywordId: string) {
    return this.delete(`/v2/smart-qc/settings/keywords/${qcKeywordId}`);
  }

  getQCCriterias(query: GetQCCriteriaQuery) {
    let url = `/v2/smart-qc/settings/criterias?page=${query.page}&page_size=${query.page_size}`;

    if (query.name) {
      url += `&name=${query.name}`;
    }

    return this.get(url);
  }

  createQCCriteria(body: CreateQCCriteriaPayload) {
    return this.post('/v2/smart-qc/settings/criterias', body);
  }

  updateQCCriteria(qcCriteriaId: string, body: UpdateQCCriteriaPayload) {
    return this.put(`/v2/smart-qc/settings/criterias/${qcCriteriaId}`, body);
  }

  deleteQCCriteria(qcCriteriaId: string) {
    return this.delete(`/v2/smart-qc/settings/criterias/${qcCriteriaId}`);
  }

  getSummaryCall(query: GetSummaryQuery) {
    return this.get(`/v2/smart-qc/summary/call?start_date=${query.start_date}&end_date=${query.end_date}`);
  }

  getSummaryEmotion(query: GetSummaryQuery) {
    return this.get(`/v2/smart-qc/summary/emotion?start_date=${query.start_date}&end_date=${query.end_date}`);
  }

  getSummaryAgent(query: GetSummaryQuery) {
    return this.get(`/v2/smart-qc/summary/agent?start_date=${query.start_date}&end_date=${query.end_date}`);
  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/SmartQC.service.ts